// extracted by mini-css-extract-plugin
export default {"container":"CardItem_container__gBGoo","number":"CardItem_number__fTSAT","button":"CardItem_button__n65WM"};